import React, { useState, useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import useIsMountedRef from './hooks/useIsMountedRef';
import { useDispatch } from './redux/store';
import { checkSession, hasError } from './redux/slices/session';
import { fetchAuthSession } from '@aws-amplify/auth';
import routes from './routes';
import withTracker from './withTracker';
import getAsyncErrorMessage from './utils/getAsyncErrorMessage';

const App = (props) => {
  const dispatch = useDispatch();
  const isMountedRef = useIsMountedRef();
  const [loading, setLoading] = useState(true);

  // login前にURLを踏んだときの場合に備えて覚えておく
  const beforeLoginPathname =
    window.location.pathname.indexOf('/login') === 0 || window.location.href.split(window.location.origin)[1] === '/' ? '' : '?r=' + window.location.href.split(window.location.origin)[1];

  useEffect(() => {
    (async () => {
      try {
        const session = await fetchAuthSession();
        // console.log(session);
        const payload = session?.tokens?.idToken?.payload;
        if (payload) {
          dispatch(checkSession());
        } else {
          const notAuthPageName = ['/login', '/forgot-password', '/verify-code', '/confirm-continuation'];
          const needLogin = notAuthPageName.filter((item) => window.location.pathname.indexOf(item) === 0).length === 0;
          if (needLogin) {
            // ログインが必要なページであればpathnameを保持してログイン画面に遷移する
            // Routeの外でhistoryが使えない＆react-route-domのバージョンの都合で使えないのでwindow.location.hrefで対応
            window.location.href = '/login' + beforeLoginPathname;
          } else {
            // ログインが必要ないページであればそのまま表示する
            // do nothing
          }
        }
      } catch (err) {
        // console.log(err);
        const message = getAsyncErrorMessage(err);
        dispatch(hasError(message));
      }
      if (isMountedRef.current) {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center vh-100">
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      </div>
    );
  } else {
    return (
      <>
        <Switch>
          {routes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                component={withTracker((routeProps) => {
                  return (
                    <route.layout accessibleRoles={route.accessibleRoles} {...props}>
                      <route.component {...props} {...routeProps} />
                    </route.layout>
                  );
                })}
              />
            );
          })}
          <Redirect to="/mill-sheet-search" />
        </Switch>
      </>
    );
  }
};

export default App;
